import React from "react";
import { motion } from "framer-motion";

function BackgroundAnimated() {
  return (
    <div className="h-full w-screen bg-gradient-to-b from-babyPurple to-pinkColor  absolute -z-10  overflow-hidden">
        {/* Top */}
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            repeat: Infinity,
            delay: 1,
          }}
          className="bg-gradient-to-t from-purpleColor to-purpleColorLight opacity-35 fixed top-0 right-0 rounded-bl-[17rem] w-[15vw] h-[15vw] md:w-[11vw] md:h-[11vw] lg:w-[6vw] lg:h-[6vw]  "
          style={{
            zIndex: "4",
          }}
        ></motion.div>
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            repeat: Infinity,
            delay: 3,
          }}
          className="bg-gradient-to-t from-purpleColor to-purpleColorLight opacity-35 fixed top-0 right-0 rounded-bl-[20rem]  w-[28vw] h-[28vw] md:w-[22vw] md:h-[22vw] lg:w-[12vw] lg:h-[12vw]"
          style={{
            zIndex: "3",
          }}
        ></motion.div>
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            repeat: Infinity,
            delay: 5,
          }}
          className="bg-gradient-to-t from-darkPurple to-purpleColorLight opacity-50 fixed top-0 right-0 rounded-bl-[30rem]  w-[43vw] h-[43vw] md:w-[33vw] md:h-[33vw] lg:w-[18vw] lg:h-[18vw]"
          style={{
            zIndex: "2",
          }}
        ></motion.div>
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            repeat: Infinity,
            delay: 7,
          }}
          className="bg-gradient-to-t from-darkPurple to-purpleColorLight opacity-35  fixed top-0 right-0 rounded-bl-[40rem]  w-[58vw] h-[58vw] md:w-[46vw] md:h-[46vw] lg:w-[24vw] lg:h-[24vw]"
          style={{
            zIndex: "1",
          }}
        ></motion.div>

        {/* bottom */}
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            repeat: Infinity,
            delay: 1,
          }}
          className="bg-gradient-to-t from-purpleColor to-purpleColorLight opacity-35 fixed bottom-0 left-0 rounded-tr-[17rem]  w-[15vw] h-[15vw] md:w-[11vw] md:h-[11vw]  lg:w-[6vw] lg:h-[6vw]"
          style={{
            zIndex: "4",
          }}
        ></motion.div>
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            repeat: Infinity,
            delay: 3,
          }}
          className="bg-gradient-to-t from-purpleColor to-purpleColorLight opacity-35 fixed bottom-0 left-0 rounded-tr-[20rem]  w-[28vw] h-[28vw] md:w-[22vw] md:h-[22vw] lg:w-[12vw] lg:h-[12vw]"
          style={{
            zIndex: "3",
          }}
        ></motion.div>
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            repeat: Infinity,
            delay: 5,
          }}
          className="bg-gradient-to-t from-darkPurple to-purpleColorLight opacity-50  fixed bottom-0 left-0 rounded-tr-[30rem]  w-[43vw] h-[43vw] md:w-[33vw] md:h-[33vw]  lg:w-[18vw] lg:h-[18vw]"
          style={{
            zIndex: "2",
          }}
        ></motion.div>
        <motion.div
          animate={{
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            repeat: Infinity,
            delay: 7,
          }}
          className="bg-gradient-to-t from-darkPurple to-purpleColorLight opacity-35 fixed bottom-0 left-0 rounded-tr-[40rem]  w-[58vw] h-[58vw] md:w-[46vw] md:h-[46vw]  lg:w-[24vw] lg:h-[24vw]"
          style={{
            zIndex: "1",
          }}
        ></motion.div>
    </div>
  );
}

export default BackgroundAnimated;
